import { chatboxPositionSchema, type Settings } from "@go-novus/admin-api";
import { Panel, SegmentedControl, SourceRow, Switch } from "@go-novus/ui";

import * as m from "#/paraglide/messages";

import type { PreviewControl } from "../hooks/use-preview-control";
import { PreviewLayout, type DraftView } from "./preview";

type Chatbox = Settings["chatbox"];

const POSITION_LABEL: Record<Chatbox["position"], () => string> = {
  bottom_left: m.settings_position_bottom_left,
  bottom_right: m.settings_position_bottom_right,
};

/** 设计稿把左放在前，契约的枚举顺序反过来，展示按设计稿。 */
const POSITION_ORDER: Chatbox["position"][] = ["bottom_left", "bottom_right"];

export interface LauncherSectionProps {
  draftView: DraftView;
  onChange: (next: Chatbox) => void;
  preview: PreviewControl;
}

/** Launcher 标签：收起入口的位置与是否允许买家拖动，右边一张预览。 */
export function LauncherSection({
  draftView,
  onChange,
  preview,
}: LauncherSectionProps) {
  const { chatbox } = draftView;

  function patch(next: Partial<Chatbox>): void {
    onChange({ ...chatbox, ...next });
  }

  return (
    <PreviewLayout draftView={draftView} preview={preview}>
      <Panel>
        <h2 className="px-4.5 pt-4.5 text-headline font-bold text-[var(--content-fg-strong)]">
          {m.settings_position_label()}
        </h2>
        <div className="p-4.5">
          <SegmentedControl
            hideLabel
            label={m.settings_position_label()}
            onChange={(value) => {
              const position = chatboxPositionSchema.safeParse(value);

              if (position.success) {
                patch({ position: position.data });
              }
            }}
            options={POSITION_ORDER.map((value) => ({
              label: POSITION_LABEL[value](),
              value,
            }))}
            value={chatbox.position}
          />
        </div>
        <div className="border-t border-[var(--border-surface-default)]">
          <SourceRow
            action={
              <Switch
                checked={chatbox.launcherDraggable}
                label={m.settings_launcher_drag_title()}
                onChange={(launcherDraggable) => {
                  patch({ launcherDraggable });
                }}
              />
            }
            copy={m.settings_launcher_drag_copy()}
            title={m.settings_launcher_drag_title()}
          />
        </div>
      </Panel>
    </PreviewLayout>
  );
}
